module.exports = require("./material-design-icons.css");



//////////////////
// WEBPACK FOOTER
// (webpack)-material-design-icons/index.js
// module id = 1711
// module chunks = 1